// 环境类型定义
type EnvType = 'development' | 'production' | 'preview'

// API配置类型
interface ApiConfig {
  baseURL: string
  prefix: string
  timeout: number
  getFullUrl: (path: string) => string
}
// 基础配置类型
interface BaseConfig {
  env: EnvType
  isDev: boolean
  isProd: boolean
  appName: string
  api: ApiConfig
}
// 资源配置类型
interface ResourceConfig {
  staticDomain: string
  uploadUrl: string
  getStaticUrl: (path: string) => string
}

// 功能开关配置类型
interface FeatureConfig {
  enableMock: boolean
  enableLog: boolean
  showDebugTool: boolean
}

// 第三方服务配置类型
interface ThirdPartyConfig {
  ossDomain: string
  mapKey: string
}

// 合并所有配置的类型
interface AppConfig extends BaseConfig {
  api: ApiConfig
  resource: ResourceConfig
  feature: FeatureConfig
  thirdParty: ThirdPartyConfig
}

// 基础配置
const baseConfig: BaseConfig = {
  // 环境类型（Vite内置环境变量）
  env: import.meta.env.MODE as EnvType,

  // 是否为开发环境（Vite内置）
  isDev: import.meta.env.DEV,

  // 是否为生产环境（Vite内置）
  isProd: import.meta.env.PROD,

  // 应用名称
  appName: import.meta.env.VITE_APP_NAME || '文鼎教育在线管理平台'
}

// API配置
const apiConfig: ApiConfig = {
  baseURL: import.meta.env.VITE_BASE_URL || '',
  prefix: import.meta.env.VITE_API_PREFIX || '/api',
  timeout: Number(import.meta.env.VITE_TIMEOUT) || 10000,

  // 完整接口地址拼接
  getFullUrl: (path: string) => {
    // 处理path可能以/开头的情况，避免出现双斜杠
    const normalizedPath = path.startsWith('/') ? path.slice(1) : path
    return `${baseConfig.isProd ? '' : baseConfig.api.baseURL}${
      apiConfig.prefix
    }/${normalizedPath}`
  }
}

// 资源配置
const resourceConfig: ResourceConfig = {
  staticDomain: import.meta.env.VITE_STATIC_DOMAIN || '',
  uploadUrl: import.meta.env.VITE_UPLOAD_URL || '/upload',

  // 获取静态资源完整路径
  getStaticUrl: (path: string) => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`
    return `${resourceConfig.staticDomain}${normalizedPath}`
  }
}

// 功能开关配置
const featureConfig: FeatureConfig = {
  enableMock: import.meta.env.VITE_ENABLE_MOCK === 'true',
  enableLog: import.meta.env.VITE_ENABLE_LOG === 'true',
  showDebugTool: import.meta.env.VITE_SHOW_DEBUG_TOOL === 'true'
}

// 第三方服务配置
const thirdPartyConfig: ThirdPartyConfig = {
  ossDomain: import.meta.env.VITE_OSS_DOMAIN || '',
  mapKey: import.meta.env.VITE_MAP_KEY || ''
}

// 导出合并后的配置
const config: AppConfig = {
  ...baseConfig,
  api: apiConfig,
  resource: resourceConfig,
  feature: featureConfig,
  thirdParty: thirdPartyConfig
}

export default config
